export const ConfirmRedirectModalTranslationKeys = {
  confirmRedirectModalTitle: 'common.warning-redirect-title',
  confirmRedirectModalDescription: 'common.warning-redirect-description',
}
